import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

// import function to register Swiper custom elements
import { register } from 'swiper/element/bundle';

import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import relativeTime from 'dayjs/plugin/relativeTime';
import utc from 'dayjs/plugin/utc';
import weekday from 'dayjs/plugin/weekday';
import localizedFormat from 'dayjs/plugin/localizedFormat';

if (environment.production) {
  enableProdMode();
}

dayjs.extend(timezone);
dayjs.tz.setDefault('Europe/Amsterdam');
dayjs.extend(relativeTime);
dayjs.extend(utc);
dayjs.extend(weekday);
dayjs.extend(localizedFormat);

// register Swiper custom elements
register();

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch((err) => console.error(err));
